<div>
  <div class="flex flex-col items-center justify-center p-8 mt-8 bg-white">
    <img height="186" [src]="image" class="h-44 -mt-16 cursor-pointer" (click)="this.onClick.emit()" />
    <span class="block mt-8 text-sm">{{ name }}</span>
  </div>
  <app-button
    [fullWidth]="true"
    [label]="'ProductCard.Configure' | translate : { short }"
    [size]="'xl'"
    [icon]="'arrow-right-alt'"
    (onClick)="this.onClick.emit()"
  ></app-button>
</div>
